import { SITE, BOAT_EXCURSIONS } from "../data/site";
import { loc } from "../data/i18n";

/** LocalBusiness JSON-LD for the home page */
export function localBusinessSchema(lang = "fr") {
    const east = lang === "en" ? "East of Mauritius" : "Est de Maurice";
    return {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": `${SITE.siteUrl}/#business`,
        name: SITE.name,
        image: SITE.logoPrimaryUrl,
        logo: SITE.logoPrimaryUrl,
        url: SITE.siteUrl,
        telephone: SITE.phone,
        email: SITE.email,
        priceRange: "Rs 1 400 – Rs 18 000+",
        address: {
            "@type": "PostalAddress",
            addressLocality: "Trou d'Eau Douce",
            addressRegion: "Flacq",
            addressCountry: "MU",
        },
        areaServed: [
            {
                "@type": "AdministrativeArea",
                name: east,
            },
            "Trou d'Eau Douce",
            "Belle Mare",
            "Poste de Flacq",
            "Île aux Cerfs",
        ],
        sameAs: [SITE.instagram, SITE.facebook].filter((s) => s && s !== "#"),
        openingHours: "Mo-Sa 08:00-19:00",
    };
}

/** TouristTrip / Product with Offer for an excursion */
export function excursionSchema(excursion, lang = "fr") {
    const e = loc(excursion, lang);
    const prefix = lang === "en" ? "/en" : "";
    return {
        "@context": "https://schema.org",
        "@type": "TouristTrip",
        name: e.name,
        description: e.seo?.description,
        image: e.image,
        touristType: "leisure",
        itinerary: {
            "@type": "ItemList",
            itemListElement: e.program.map((step, i) => ({
                "@type": "ListItem",
                position: i + 1,
                item: {
                    "@type": "Place",
                    name: step,
                },
            })),
        },
        offers: {
            "@type": "Offer",
            price: e.basePrice,
            priceCurrency: "MUR",
            availability: "https://schema.org/InStock",
            url: `${SITE.siteUrl}${prefix}/${e.slug}`,
            eligibleQuantity: {
                "@type": "QuantitativeValue",
                minValue: e.includedPax,
            },
        },
        provider: {
            "@type": "LocalBusiness",
            name: SITE.name,
            areaServed: lang === "en" ? "East of Mauritius" : "Est de Maurice",
        },
    };
}

/** Full site JSON-LD collection */
export function homePageSchemas(lang = "fr") {
    return [
        localBusinessSchema(lang),
        ...BOAT_EXCURSIONS.map((e) => excursionSchema(e, lang)),
    ];
}
